export enum PathEstimator {
    Estimator = '/estimator',
    EstimationWizard = '/estimator/:projectId/wizard',
    EstimationProcess = '/estimator/:projectId/wizard/:stepId',
    EstimationStepVolumes = '/estimator/:projectId/wizard/volumes',
    EstimationStepPlausibility = '/estimator/:projectId/wizard/plausibility',
}
